import { inject, Injectable } from '@angular/core';
import { OrderStateServiceV2 } from './order-state.service';
import { OrderSetupStateService } from './workflows/order-setup/order-setup-state.service';
import { ServiceInformationCollectionStateService } from './workflows/service-info-collection/service-info-collection-state.service';
import { OrderApiResponseStateService } from './order-api-response/order-api-response-state.service';
import { CreditCheckStateService } from './workflows/credit-check/credit-check-state.service';
import { InternetFlowStateService } from './workflows/internet/internet-flow-state.service';
import { InternetPackageSelectionStateService } from './workflows/internet/internet-package-selection/internet-package-selection-state.service';
import { WirelessSetupStateService } from './workflows/wireless/wireless-setup.state.service';
import { AdvanceBillPaymentStateService } from './workflows/advance-bill-payment/advance-bill-payment.state.service';
import { AdditionalInternetOffersStateService } from './workflows/internet/additional-internet-offers/additional-internet-offers.state.service';
import { WirelessSigfanStateService } from './workflows/wireless/wireless-sigfan.state.service';
import { WirelessIdAuthenticationStateService } from './workflows/wireless/wireless-id-authentication.state.service';
import { WirelessFlowStateService } from './workflows/wireless/wireless-flow-state.service';
import { WirelessAdditionalOffersStateService } from './workflows/wireless/wireless-additional-offers.state.service';
import { MobileBusinessAgreementStateService } from './workflows/wireless/mobile-business-agreement.state.service';
import { CustomerAccountSetupStateService } from './workflows/cutomer-account-setup/customer-account-setup.state.service';
import { AlternateShippingAddressStateService } from './workflows/alternate-shipping-address/alternate-shipping-address.state.service';
import { OrderSummaryStateService } from './workflows/order-summary/order-summary.state.service';
import { InstallationSchedulingStateService } from './workflows/installation-scheduling/installation-scheduling.state.service';
import { ProductSummaryStateService } from './workflows/product-summary/product-summary.state.service';
import { TermsAndConditionsStateService } from './workflows/terms-and-conditions/terms-and-conditions.state.service';
import { OrderChecklistStateService } from './workflows/order-checklist/order-checklist.state.service';
import { WirelessLineConfigurationStateService } from './workflows/wireless/wireless-line-configuration.state.service';
import { PaymentInformationEntryStateService } from './workflows/payment-information-entry/payment-information-entry.state.service';
import { VideoFlowStateService } from './workflows/video/video-flow-state.service';
import { StreamHardwareSelectionStateService } from './workflows/video/stream-hardware-selection/stream-hardware-selection.state.service';
import { VideoPackageSelectionStateService } from './workflows/video/video-package-selection/video-package-selection-state.service';
import { AdditionalVideoOffersStateService } from './workflows/video/additional-video-offers/additional-video-offers.state.service';
import { VideoAdditionalChannelOffersStateService } from './workflows/video/video-optional-channel-offers/video-optional-channel-offers.state.service';
import { SatelliteHardwareSelectionStateService } from './workflows/video/satellite-hardware-selection/satellite-hardware-selection.state.service';
import { ClosingOffersStateService } from './workflows/video/closing-offers/closing-offers.state.service';
import { EmailValidationStateService } from './workflows/video/email-validation/email-validation.state.service';
import { StreamGenrePackStateService } from './workflows/video/stream-genre-pack/stream-genre-pack.state.service';
import { ServiceLevelSelectionStateService } from './workflows/wireless/service-level-selection/service-level-selection.state.service';
import { DTVVideoCommericalSatelliteOffersStateService } from './workflows/video/eqipment-offers/dtv-video-commerical-satellite-offers.state.service';
import { InstallationChecklistStateService } from './workflows/installation-checklist/installation-checklist.state.service';
import { BusinessVerificationStateService } from './workflows/wireless/business-verification/business-verification.state.service';
import { PreviousAddressStateService } from './workflows/previous-address/previous-address-state.service';
import { VoiceFlowStateService } from './workflows/voice/voice-flow-state.service';
import { VoicePackageSelectionStateService } from './workflows/voice/voice-package-selection/voice-package-selection-state.service';
import { VoiceConfigurationStateService } from './workflows/voice/voice-configuration/voice-configuration-state.service';
import { AdditionalVoiceOffersStateService } from './workflows/voice/additional-voice-offers/additional-voice-offers.state.service';
import { IdentityVerificationStateService } from './workflows/credit-check/identity-verification/identity-verification-state.service';
import { CustomerOrderVerificationStateService } from './workflows/customer-order-verification/customer-order-verification-state.service';

@Injectable({ providedIn: 'root' })
export class OrderStateApiBridgeService {
    private orderStateService: OrderStateServiceV2 = inject(OrderStateServiceV2);
    private orderApiResponseStateService: OrderApiResponseStateService = inject(OrderApiResponseStateService);
    private orderSetupStateService: OrderSetupStateService = inject(OrderSetupStateService);
    private serviceInfoCollectionStateService = inject(ServiceInformationCollectionStateService);
    private creditCheckStateService = inject(CreditCheckStateService);
    private internetFlowStateService = inject(InternetFlowStateService);
    private internetPackageSelectionStateService = inject(InternetPackageSelectionStateService);
    private wirelessFlowStateService = inject(WirelessFlowStateService);
    private businessVerificationStateService = inject(BusinessVerificationStateService);
    private wirelessSetupStateService = inject(WirelessSetupStateService);
    private advanceBillPaymentStateService = inject(AdvanceBillPaymentStateService);
    private additionalInternetOffersStateService = inject(AdditionalInternetOffersStateService);
    private wirelessSigfanStateService = inject(WirelessSigfanStateService);
    private wirelessIdAuthenticationStateService = inject(WirelessIdAuthenticationStateService);
    private wirelessAdditionalOffersStateService = inject(WirelessAdditionalOffersStateService);
    private mobileBusinessAgreementStateService = inject(MobileBusinessAgreementStateService);
    private customerAccountSetupStateService = inject(CustomerAccountSetupStateService);
    private alternateShippingAddressStateService = inject(AlternateShippingAddressStateService);
    private serviceLevelSelectionStateService = inject(ServiceLevelSelectionStateService);
    private orderSummaryStateService = inject(OrderSummaryStateService);
    private installationSchedulingStateService = inject(InstallationSchedulingStateService);
    private installationChecklistStateService = inject(InstallationChecklistStateService);
    private productSummaryStateService = inject(ProductSummaryStateService);
    private termsAndConditionsStateService = inject(TermsAndConditionsStateService);
    private orderChecklistStateService = inject(OrderChecklistStateService);
    private wirelessLineConfigurationStateService = inject(WirelessLineConfigurationStateService);
    private paymentInformationEntryStateService = inject(PaymentInformationEntryStateService);
    private videoFlowStateService = inject(VideoFlowStateService);
    private streamHardwareSelectionStateService = inject(StreamHardwareSelectionStateService);
    private videoPackageSelectionStateService = inject(VideoPackageSelectionStateService);
    private videoAdditionalChannelOffersStateService = inject(VideoAdditionalChannelOffersStateService);
    private videoClosingOffersStateService = inject(ClosingOffersStateService);
    private previousAddressStateService = inject(PreviousAddressStateService);
    private additionalVideoOffersStateService = inject(AdditionalVideoOffersStateService);
    private satelliteHardwareSelectionStateService = inject(SatelliteHardwareSelectionStateService);
    private emailValidationStateService = inject(EmailValidationStateService)
    private streamGenrePackStateService = inject(StreamGenrePackStateService)
    private dtvVideoCommericalSatelliteOffersStateService = inject(DTVVideoCommericalSatelliteOffersStateService)
    private voiceFlowStateService = inject(VoiceFlowStateService);
    private voicePackageSelectionStateService = inject(VoicePackageSelectionStateService);
    private voiceConfigurationStateService = inject(VoiceConfigurationStateService);
    private additionalVoiceOffersStateService = inject(AdditionalVoiceOffersStateService);
    private identityVerificationStateService = inject(IdentityVerificationStateService);
    private customerOrderVerificationStateService = inject(CustomerOrderVerificationStateService);
    private initialized = false;

    /** Load everything from local draft */
    init(): void {
        if (this.initialized) return; // skip if already init
        this.initialized = true;
        // 1. Load root from sessionStorage
        this.orderStateService.loadFromLocal();

        if (this.orderStateService.isValidOrder()) {
            // 2. Hydrate child slices from root order
            const order = this.orderStateService.order();

            if (order?.orderSetup) {
                this.orderSetupStateService.loadFromOrder(order.orderSetup);
            }

            if (order.serviceInfoCollection) {
                this.serviceInfoCollectionStateService.loadFromOrder(order.serviceInfoCollection);
            }

            if (order?.creditCheck) {
                this.creditCheckStateService.loadFromOrder(order.creditCheck);

                if (order.creditCheck.identityVerification) {
                    this.identityVerificationStateService.loadFromOrder(order.creditCheck.identityVerification);
                }
            }

            if (order?.customerOrderVerification) {
                this.customerOrderVerificationStateService.loadFromOrder(order.customerOrderVerification);
            }
            
            if (order.previousAddress) {
                    this.previousAddressStateService.loadFromOrder(order.previousAddress);
            }

            if (order?.advanceBillPayment) {
                this.advanceBillPaymentStateService.loadFromOrder(order.advanceBillPayment);
            }

            if (order.customerAccountSetup) {
                this.customerAccountSetupStateService.loadFromOrder(order.customerAccountSetup);
            }

            if (order.alternateShippingAddress) {
                this.alternateShippingAddressStateService.loadFromOrder(order.alternateShippingAddress);
            }

            if (order.orderSummary) {
                this.orderSummaryStateService.loadFromOrder(order.orderSummary);
            }

            if (order?.installationScheduling) {
                this.installationSchedulingStateService.loadFromOrder(order.installationScheduling);
            }

            if (order?.installationChecklist) {
                this.installationChecklistStateService.loadFromOrder(order.installationChecklist);
            }

            if (order.productSummary) {
                this.productSummaryStateService.loadFromOrder(order.productSummary);
            }

            if (order.termsAndConditions) {
                this.termsAndConditionsStateService.loadFromOrder(order.termsAndConditions);
            }

            if (order.orderChecklist) {
                this.orderChecklistStateService.loadFromOrder(order.orderChecklist);
            }

            if (order.paymentInformationEntry) {
                this.paymentInformationEntryStateService.loadFromOrder(order.paymentInformationEntry);
            }

            if (order?.internetFlow) {
                this.internetFlowStateService.loadFromOrder(order.internetFlow);

                if (order.internetFlow.internetPackageSelection) {
                    this.internetPackageSelectionStateService.loadFromOrder(order.internetFlow.internetPackageSelection);
                }

                if (order.internetFlow.internetOffers) {
                    this.additionalInternetOffersStateService.loadFromOrder(order.internetFlow.internetOffers);
                }
            }

            if (order?.wirelessFlow) {
                this.wirelessFlowStateService.loadFromOrder(order.wirelessFlow);

                if (order.wirelessFlow.sigfan) {
                    this.wirelessSigfanStateService.loadFromOrder(order.wirelessFlow.sigfan);
                }

                if (order.wirelessFlow.wirelessSetup) {
                    this.wirelessSetupStateService.loadFromOrder(order.wirelessFlow.wirelessSetup);
                }

                if (order.wirelessFlow.businessVerification) {
                    this.businessVerificationStateService.loadFromOrder(order.wirelessFlow.businessVerification);
                }

                if (order.wirelessFlow.wirelessOffers) {
                    this.wirelessAdditionalOffersStateService.loadFromOrder(order.wirelessFlow.wirelessOffers);
                }

                if (order.wirelessFlow.mobileBusinessAgreement) {
                    this.mobileBusinessAgreementStateService.loadFromOrder(order.wirelessFlow.mobileBusinessAgreement);
                }

                if (order.wirelessFlow.wirelessIdAuthentication) {
                    this.wirelessIdAuthenticationStateService.loadFromOrder(order.wirelessFlow.wirelessIdAuthentication);
                }

                if (order.wirelessFlow.lineConfigurations) {
                    this.wirelessLineConfigurationStateService.loadFromOrder(order.wirelessFlow.lineConfigurations);
                }

                if (order.wirelessFlow.serviceLevelSelection) {
                    this.serviceLevelSelectionStateService.loadFromOrder(order.wirelessFlow.serviceLevelSelection);
                }
            }

            if (order?.videoFlow) {
                this.videoFlowStateService.loadFromOrder(order.videoFlow);

                if (order.videoFlow.videoPackageSelection) {
                    this.videoPackageSelectionStateService.loadFromOrder(order.videoFlow.videoPackageSelection);
                }

                if (order.videoFlow.streamhardwareSelection) {
                    this.streamHardwareSelectionStateService.loadFromOrder(order.videoFlow.streamhardwareSelection);
                }

                if (order.videoFlow.videoAdditionalChannelOffers) {
                    this.videoAdditionalChannelOffersStateService.loadFromOrder(order.videoFlow.videoAdditionalChannelOffers);
                }
                if (order.videoFlow.videoClosingOffers) {
                    this.videoClosingOffersStateService.loadFromOrder(order.videoFlow.videoClosingOffers);
                }

                if (order.videoFlow.videoOffers) {
                    this.additionalVideoOffersStateService.loadFromOrder(order.videoFlow.videoOffers);
                }

                if (order.videoFlow.satelliteHardwareSelection) {
                    this.satelliteHardwareSelectionStateService.loadFromOrder(order.videoFlow.satelliteHardwareSelection);
                }

                if (order.videoFlow.emailValidation) {
                    this.emailValidationStateService.loadFromOrder(order.videoFlow.emailValidation);
                }

                if (order.videoFlow.genrePackageSelection) {
                    this.streamGenrePackStateService.loadFromOrder(order.videoFlow.genrePackageSelection);
                }

                if (order.videoFlow.dtvVideoCommericalSatelliteEquipmentOffers) {
                    this.dtvVideoCommericalSatelliteOffersStateService.loadFromOrder(order.videoFlow.dtvVideoCommericalSatelliteEquipmentOffers);
                }
            }

            if (order?.voiceFlow) {
                this.voiceFlowStateService.loadFromOrder(order.voiceFlow);

                if (order.voiceFlow.voicePackageSelection) {
                    this.voicePackageSelectionStateService.loadFromOrder(order.voiceFlow.voicePackageSelection);
                }

                if (order.voiceFlow.voiceConfiguration) {
                    this.voiceConfigurationStateService.loadFromOrder(order.voiceFlow.voiceConfiguration);
                }

                if (order.voiceFlow.voiceOffers) {
                    this.additionalVoiceOffersStateService.loadFromOrder(order.voiceFlow.voiceOffers);
                }
            }

        } else {
            // Lets check if API has order data
            if (this.orderApiResponseStateService.hasOrderData()) {
                const orderData = this.orderApiResponseStateService.orderData();
                this.orderStateService.loadFromOrder(orderData);
            }

        }
    }
}
